export const USER_ROLE_CIRCLE_KEEPER = 'Circle Keeper';
export const USER_ROLE_COACH = 'Coach';
export const USER_ROLE_CONCILIATOR = 'Conciliator';
export const USER_ROLE_COORDINATOR = 'Coordinator';
export const USER_ROLE_CONSULTANT = 'Consultant';
export const USER_ROLE_MEDIATOR = 'Mediator';

export const USER_ROLE_OTHER_ID = '507f191e810c19729de86111';
